import angular from 'angular'

import { VD_CLASSES } from '../../constants'
import template from './vd-dialog-drawer.html'

/**
 * A dialog drawer, usually invoked via the `Modal` service.
 *
 * @param {string} header The dialog header
 *
 * @param {function} close The method to invoke on close
 *
 * @param {html} transclusion The content of the dialog.  `.vd-dialog-content` element is required which should house
 *                            the main content of the dialog.
 *
 */
angular.module('vend.ui').directive('vdDialogDrawer', function ($document) {
  return {
    transclude: true,
    scope: {
      close: '=close',
      dismissible: '=',
    },
    template,
    link: {
      pre: (scope, iElement, iAttrs, controller, transcludeFn) => {
        const dialogContainerElement = angular.element(
          iElement[0].querySelector('.vd-dialog-drawer-container')
        )

        iElement.addClass('vd-dialog')

        transcludeFn(transcludeEl =>
          dialogContainerElement.append(transcludeEl)
        )
      },
    },
    controller($scope) {
      // Add and remove class to body for preventing scrolling when modal is open
      const bodyNode = $document.find('body')

      bodyNode.addClass(VD_CLASSES.noBodyScroll)

      $scope.$on('$destroy', () => {
        bodyNode.removeClass(VD_CLASSES.noBodyScroll)
      })
    },
  }
})
